if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.onModalSliderScroll = this.onModalSliderScroll.bind(this);
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        requestAnimationFrame(() => {
          this.initModalSlider();
          this.syncSliderComponent();
        });
      }

      getModalSlider() {
        return this.querySelector('[id^="Slider-ProductModal"]');
      }

      getVisibleModalSlides() {
        return Array.from(this.querySelectorAll('.product-media-modal__slide')).filter((slide) => {
          return slide.offsetWidth > 0 && getComputedStyle(slide).display !== 'none';
        });
      }

      getModalSlideIndex() {
        const slider = this.getModalSlider();
        const slides = this.getVisibleModalSlides();

        if (!slider || !slides.length) return 0;

        const scrollLeft = slider.scrollLeft;
        let activeIndex = 0;

        slides.forEach((slide, index) => {
          if (slide.offsetLeft <= scrollLeft + 16) activeIndex = index;
        });

        return activeIndex;
      }

      goToModalSlide(index, behavior = 'smooth') {
        const slider = this.getModalSlider();
        const slides = this.getVisibleModalSlides();
        const targetSlide = slides[index];

        if (!slider || !targetSlide) return;

        slider.scrollTo({
          left: targetSlide.offsetLeft,
          behavior,
        });

        this.updateModalSliderUi(index, slides.length);
      }

      updateModalSliderUi(activeIndex = this.getModalSlideIndex(), total = this.getVisibleModalSlides().length) {
        const prevButton = this.querySelector('.product-media-modal__slider .slider-button--prev');
        const nextButton = this.querySelector('.product-media-modal__slider .slider-button--next');
        const currentCounter = this.querySelector('.product-media-modal__counter .slider-counter--current');
        const totalCounter = this.querySelector('.product-media-modal__counter .slider-counter--total');

        if (currentCounter) currentCounter.textContent = activeIndex + 1;
        if (totalCounter) totalCounter.textContent = total;

        if (prevButton) prevButton.toggleAttribute('disabled', activeIndex <= 0);
        if (nextButton) nextButton.toggleAttribute('disabled', activeIndex >= total - 1);
      }

      onModalSliderScroll() {
        window.clearTimeout(this.modalSliderScrollTimer);
        this.modalSliderScrollTimer = window.setTimeout(() => {
          this.updateModalSliderUi();
        }, 80);
      }

      initModalSlider() {
        const slider = this.getModalSlider();
        const prevButton = this.querySelector('.product-media-modal__slider .slider-button--prev');
        const nextButton = this.querySelector('.product-media-modal__slider .slider-button--next');
        const slides = this.getVisibleModalSlides();

        if (!slider || slides.length < 2) return;

        if (!this.modalSliderReady) {
          this.modalSliderReady = true;

          prevButton?.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.goToModalSlide(this.getModalSlideIndex() - 1);
          });

          nextButton?.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.goToModalSlide(this.getModalSlideIndex() + 1);
          });

          slider.addEventListener('scroll', this.onModalSliderScroll, { passive: true });
        }

        this.updateModalSliderUi();
      }

      syncSliderComponent() {
        const sliderComponent = this.querySelector('slider-component');

        if (sliderComponent?.resetPages) {
          sliderComponent.resetPages();
        }
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');

        this.querySelectorAll('.product-media-modal__slide').forEach((slide) => {
          slide.classList.remove('active');
        });

        const activeSlide =
          this.querySelector(`.product-media-modal__slide[data-media-id="${mediaId}"]`) ||
          this.querySelector(`[data-media-id="${mediaId}"]`)?.closest('.product-media-modal__slide');

        if (!activeSlide) return;

        activeSlide.classList.add('active');

        const slides = this.getVisibleModalSlides();
        const activeIndex = Math.max(slides.indexOf(activeSlide), 0);

        this.goToModalSlide(activeIndex, 'auto');

        const activeMedia =
          activeSlide.querySelector('deferred-media, product-model') || activeSlide.querySelector('[data-media-id]');

        if (!activeMedia) return;

        activeMedia.classList.add('active');

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
